export default __webpack_public_path__ + "static/media/OpenSans-Italic-VariableFont.f72efa63.ttf";